import { PlataformaProdutoResponse } from "./plataforma-produto-response";
import { ProdutoFamiliaModel } from "./produto-familia.model";

export class ProdutoModel {
    public apelido: string;
    public aplicacao: string;
    public categoria: any;
    public codBarra: number;
    public codCategoria: number;
    public codEmpresa: string;
    public codFabrica: string;
    public cstPis: string = '07';
    public cstCofins: string = '07';
    //ProdutosMarcas;
    public codFamilia: number;
    public codFornecedor: string;
    //ProdutosCategorias;
    public codMarca: number;
    //ProdutosFamilia;
    public codTipo: number;
    public codigo: number;
    //ProdutosTipo;
    public custo: number;
    public familia: any;
    public marca: any;
    public nome: string;
    public qtd: number;
    public tipoProduto: any;
    public unmed: string;
    public utilizaBalanca: boolean;
    public valorVenda: number;
    public excluido: boolean;
    public plataformasDisponiveis: PlataformaProdutoResponse[] = [];
    public composicao: ComposicaoResponse[] = [];
}

export class ProdutoResponse {
    public codigo: number = 0;
    public codBarra: number = 0;
    public codEmpresa: Number = 0;
    public codFamilia: number = 0;
    public codCategoria: number = 0;
    public nome: string = '';
    public estoque: number = 0;
    public venda: number = 0;
    public vendaPromocional: number = 0;
    public marca: string = '';
    public familia: string = '';
    public valorCusto: number = 0;
    public ativo: boolean = false;
    public composicao: ComposicaoResponse[] = [];
    public precoPromocionalAtivo: boolean = false;
}

export class ProdutoRequest {
    codigo: number = 0;
    nome: string = '';
    codBarra: number = 0;
    aplicacao: string = '';
    codTipo: number = 0;
    codCategoria: number;
    codFamilia: number;
    valorVenda: number;
    utilizaBalanca: boolean;
    unMed: string = 'UN';
    codUsuario: number = 0;
    ingredientes: IngredienteProdutoRequest[] = [];
    adicionais: AdicionalProdutoRequest[] = [];
}

export class ComposicaoResponse {
    public codigo: number = 0;
    public codigoProduto: number = 0;
    public codigoMatPrima: number = 0;
    public codigoTipo: number = 0;
}

export class IngredienteProdutoResponse {
    public codigoProduto: number = 0;
    public nome: string = '';
    public codigo: number = 0;
}

export class AdicionalProdutoResponse {
    public codigoProduto: number = 0;
    public precoAdicional: number = 0;
    public nome: string = '';
    public codigo: number = 0;
}

export class IngredienteProdutoViewModel {
    public nome: string = '';
    public codigo: number = 0;
}

export class AdicionalProdutoViewModel {
    public nome: string = '';
    public codigo: number = 0;
    public precoAdicional: number = 0;
}

export class IngredienteLoteProdutoComposicaoRequest {
    public nome: string = '';
    public codigosProdutos: number[] = [];
}

export class IngredienteProdutoRequest {
    public nome: string = '';
    public codigoProduto: number = 0;
}

export class AdicionalProdutoRequest {
    public nome: string = '';
    public codigoProduto: number = 0;
    public precoAdicional: number = 0;
}

export class AdicionalFamiliaRequest {
    public nome: string = '';
    public codigoFamilia: number = 0;
    public precoAdicional: number = 0;
}

export class ProdutoIntegradorModel {
    public aplicacao: string;
    public codigo: number;
    public codigoFamilia: number;
    public familia: ProdutoFamiliaModel;
    public nome: string;
    public unmed: string;
    public valorVenda: number;

    // Não vem do backend
    public qtd: number;
}

export class ProdutoBalancaModel {
    constructor(public produto: ProdutoModel) { }

    public qtde: number = 1;
    public valorUnit: number = 0;
    public valorTotal: number = 0;

    public setQtdePorValorTotal() {
        if (this.valorUnit > 0)
            this.qtde = Number.parseFloat(((this.valorTotal / this.valorUnit)).toFixed(3));
    }

    public setValorTotal() {
        if (this.qtde == 0) this.qtde = 1;

        this.valorTotal = Number.parseFloat(((this.valorUnit * this.qtde)).toFixed(2));
    }
}

export class ProdutoComEmpresaResponse {
    public codigo: number = 0;
    public familia: string = '';
    public nome: string = '';
    public nomePessoaIntegracao: string = '';
    public codigoFamilia: number = 0;
    public codigoCategoria: number = 0;
    public codigoProduto: number = 0;
    public codigoPessoaEmpresaIntegracao: number = 0;
    public codigoIntegracao: number = 0;
    public precoLoja: number = 0;
    public precoIntegracao: number = 0;
    public acrescimoReais: number = 0;
    public acrescimoPorCento: number = 0;
    public checkedInitial: boolean = false;
    public permitirObs: boolean = false;
}


export class ProdutoComEmpresaView {
    public codigo: number = 0;
    public familia: string = '';
    public nome: string = '';
    public nomePessoaIntegracao: string = '';
    public codigoFamilia: number = 0;
    public codigoCategoria: number = 0;
    public codigoProduto: number = 0;
    public codigoPessoaEmpresaIntegracao: number = 0;
    public codigoIntegracao: number = 0;
    public precoLoja: number = 0;
    public checkedInitial: boolean = false;
    public dataChanged: boolean = false;

    private _permitirObs: boolean = false;
    private _checked: boolean = false;
    private _truncarValorVenda: boolean = false;

    //#region PROPRIEDADES somente para os input de valor
    //os valores dos input devem ficar isolados das propriedades de request
    private _precoIntegracaoInput: number = -1;
    private _acrescimoPorCentoInput: number = -1;
    private _acrescimoReaisInput: number = -1;

    public get acrescimoPorCentoInput(): number {
        return this._acrescimoPorCentoInput === -1 ? this.acrescimoPorCento : this._acrescimoPorCentoInput;
    }

    public get acrescimoReaisInput(): number {
        return this._acrescimoReaisInput === -1 ? this.acrescimoReais : this._acrescimoReaisInput;
    }

    public get precoIntegracaoInput(): number {
        return this._precoIntegracaoInput === -1 ? this.precoIntegracao : this._precoIntegracaoInput;
    }

    public set acrescimoPorCentoInput(porcetagem: number) {
        if (this._acrescimoPorCentoInput !== porcetagem) {
            this.dataChanged = true;
            this._acrescimoPorCentoInput = porcetagem;

            if (this.acrescimoReais > 0) {
                this.acrescimoReais = 0;
                this.acrescimoReaisInput = 0;
            }

            this.acrescimoPorCento = porcetagem;
        }
    }

    public set acrescimoReaisInput(valor: number) {
        if (this._acrescimoReaisInput !== valor) {
            this.dataChanged = true;
            this._acrescimoReaisInput = valor;

            if (valor == 0 || !valor)
                return;

            if (this.acrescimoPorCento > 0) {
                this.acrescimoPorCento = 0;
                this._acrescimoPorCentoInput = 0;
            }

            this.acrescimoReais = valor;
        }
    }

    public set precoIntegracaoInput(valor: number) {
        // debugger
        if (this._precoIntegracaoInput !== valor) {
            this.dataChanged = true;
            this._precoIntegracaoInput = valor;
        }
    }

    //#endregion

    public acrescimoReais: number = 0;
    public precoIntegracao: number = 0;
    public acrescimoPorCento: number = 0;

    public get permitirObs(): boolean {
        return this._permitirObs;
    }

    public set permitirObs(value: boolean) {
        if (this._permitirObs !== value) {
            this.dataChanged = true;
            this._permitirObs = value;
        }
    }

    public get checked(): boolean {
        return this._checked;
    }

    public set checked(value: boolean) {
        if (this._checked !== value) {
            this.dataChanged = true;
            this._checked = value;
        }
    }

    public get truncarValorVenda(): boolean {
        return this._truncarValorVenda;
    }

    public set truncarValorVenda(valor: boolean) {
        if (this._truncarValorVenda !== valor) {
            this.dataChanged = true;
            this._truncarValorVenda = valor;
        }
    }

    public calcularPrecoFinal(): void {
        if ((this._precoIntegracaoInput > 0) && this.precoIntegracao !== this._precoIntegracaoInput) {
            this.acrescimoReais = 0;

            const acrescimoReias = this._precoIntegracaoInput - this.precoLoja;
            if (acrescimoReias > 0) {
                this._acrescimoReaisInput = acrescimoReias;
            }
        }

        if (this._acrescimoPorCentoInput > 0) {
            this._acrescimoReaisInput = 0;

            const valorEmReaisDaPorcentagem = Number.parseFloat(((this.precoLoja * this._acrescimoPorCentoInput) / 100).toFixed(2));
            this._precoIntegracaoInput = this.precoLoja + valorEmReaisDaPorcentagem;
        }

        if (this._acrescimoReaisInput > 0) {
            this._acrescimoPorCentoInput = 0;

            this.acrescimoReais = this._acrescimoReaisInput;
            this._precoIntegracaoInput = this.precoLoja + this._acrescimoReaisInput;
        }

        if (this._precoIntegracaoInput > 0) {
            this.precoIntegracao = this._precoIntegracaoInput;
        }
    }
}

export class PlataformaResponse {
    public nome: string = '';
    public codigo: number = 0;
}

export class GrupoIntegracaoStatusRequest {
    public codigo: number = 0;
    public codigoFamilia: number = 0;
    public codigoPessoaIntegracao: number = 0;
    public checked: boolean = false;
}

export class GrupoIntegracaoRequest {
    public codigo: number = 0;
    public codigoFamilia: number = 0;
    public codigoPessoaIntegracao: number = 0;
    public nomePessoaIntegracao: string = '';
    public acrescimoReais: number = 0;
    public acrescimoPorcento: number = 0;
    public truncarValorVenda: boolean = false;
    public checked: boolean = false;
}

export class GrupoIntegracaoResponse {
    public codigo: number = 0;
    public acrescimoReais: number = 0;
    public checked: boolean = false;
    public acrescimoPorcento: number = 0;
    public truncarValorVenda: number = 0;
    public nome: string = '';
    public codigoPessoaIntegracao: number = 0;
    public nomePessoaIntegracao: string = '';
    public codigoFamilia: number = 0;
}

export class GrupoIntegracaoViewModel {
    public nome: string = '';
    public acrescimoReais: number = 0;
    public acrescimoPorcento: number = 0;
    public checked: boolean = false;
    public truncarValorVenda: boolean = false;
    public codigo: number = 0;
    public codigoPessoaIntegracao: number = 0;
    public codigoFamilia: number = 0;
    public nomePessoaIntegracao: string = '';

    private acrescimoReaisInicial: number = 0;
    private acrescimoPorcentoInicial: number = 0;
    private checkedInicial: boolean = false;
    private truncarValorVendaInicial: boolean = false;

    public carregarValoresIniciais() {
        this.acrescimoReaisInicial = this.acrescimoReais;
        this.acrescimoPorcentoInicial = this.acrescimoPorcento;
        this.checkedInicial = this.checked;
        this.truncarValorVendaInicial = this.truncarValorVenda;
    }

    public usarValoresIniciais() {
        this.acrescimoReais = this.acrescimoReaisInicial;
        this.acrescimoPorcento = this.acrescimoPorcentoInicial;
        this.checked = this.checkedInicial;
        this.truncarValorVenda = this.truncarValorVendaInicial;
    }

    public ouveMundaca(): boolean {
        return (
            this.acrescimoReaisInicial !== this.acrescimoReais ||
            this.acrescimoPorcentoInicial !== this.acrescimoPorcento ||
            this.checkedInicial !== this.checked ||
            this.truncarValorVendaInicial !== this.truncarValorVenda
        )
    }
}

export class FamiliaResponse {
    public nome: string = ''
    public codigo: number = 0;
    public codigoPessoaIntegracao: number = 0;
    public nomePessoaIntegracao: string = '';
    private _truncarValorPara: boolean = false;
    public dataChanged: boolean = false;
    private _checked: boolean = false;
    private _acrescimoReais: number = 0;
    private _acrescimoPorcento: number = 0;

    public get checked(): boolean {
        return this._checked;
    }

    public set checked(value: boolean) {
        if (this._checked !== value) {
            this.dataChanged = true;
            this._checked = value;
        }
    }

    public get truncarValorPara(): boolean {
        return this._truncarValorPara;
    }

    public set truncarValorPara(value: boolean) {
        if (this._truncarValorPara !== value) {
            this.dataChanged = true;
            this._truncarValorPara = value;
        }
    }

    public get acrescimoReais(): number {
        return this._acrescimoReais;
    }

    public set acrescimoReais(value: number) {
        if (this._acrescimoReais !== value) {
            this.dataChanged = true;
            this._acrescimoReais = value;
        }
    }

    public get acrescimoPorcento(): number {
        return this._acrescimoPorcento;
    }

    public set acrescimoPorcento(value: number) {
        if (this._acrescimoPorcento !== value) {
            this.dataChanged = true;
            this._acrescimoPorcento = value;
        }
    }
}

export class ProdutosParaVendaRequest {
    codigoProduto: number = 0;
    codigoPessoaIntegracao = 0;
    produtoIntegracaoId: number = 0;
    checked: boolean = false;
    truncarValorVenda: boolean = false;
    acrescimoPorCento: number = 0;
    acrescimoReais: number = 0;
    precoFinal: number = 0;
    permitirObs: boolean = false;

    static Get(ProdIntegracaoId: number, Checked: boolean) {
        return { produtoIntegracaoId: ProdIntegracaoId, checked: Checked }
    }
}

export class PizzaLasanhaPrecoStatusRequest {
    public codigoProduto: number = 0;
    public precoVenda: number = 0;
    public precoVendaPromocional: number = 0;
    public ativo: boolean = false;
    public usarPrecoPromocional: boolean = false;
    public codigoTabelaPreco: number = 0;
    public atualizarPrecoIntegracao: boolean = false;

    public static Get(codProduto: number, Ativo: boolean, preco: number, precoPromocional: number, codigoTabelaPreco: number, usarPrecoPromocional: boolean, atualizarPrecoIntegracao: boolean): PizzaLasanhaPrecoStatusRequest {
        return {
            codigoProduto: codProduto,
            ativo: Ativo,
            precoVenda: preco,
            precoVendaPromocional: precoPromocional,
            codigoTabelaPreco: codigoTabelaPreco,
            usarPrecoPromocional: usarPrecoPromocional,
            atualizarPrecoIntegracao: atualizarPrecoIntegracao
        };
    }
}

export class ProdutosPizzaLasanhaComEmpresa {
    precoLoja: number = 0;
    sabor: string = '';
    checked: boolean = false;
    caracteristicas: ProdutoPizzaLasanhaComEmpresa[] = [];
    // precoPorTamanho: { [key: string]: number } = {};
    precoPorTamanho: Map<String, number> = new Map<string, number>();
}

export class ProdutoPizzaLasanhaComEmpresa {
    dataChanged: boolean = false;
    codigoProduto: number = 0;
    codigoIntegracao: number = 0;
    codigoPessoaIntegracao: number = 0;
    nomePessoaIntegracao: string = '';
    tamanho: string = '';

    private _precoVenda: number = 0;
    private _checked: boolean = false;

    public get checked(): boolean {
        return this._checked;
    }

    public set checked(status: boolean) {
        if (this._checked !== status) {
            // this.dataChanged = true;
            this._checked = status;
        }
    }

    public get precoVenda(): number {
        return this._precoVenda;
    }

    public set precoVenda(preco: number) {
        if (this._precoVenda !== preco) {
            this.dataChanged = true;
            this._precoVenda = preco;
        }
    }
}


export class ExcluirPizzaLasanhaLasanhaRequest {
    public TipoProduto: string = '';
    public Sabor: string = '';
}

export class ProdutoSemEmpresa {
    codigo: number = 0;
    familia: string = '';
    nome: string = '';
    checked: boolean = true;
}

export class ProdutosIntegracaoResponse {
    empresasIntegracao: PlataformaResponse[] = []
    produtos: ProdutoSemEmpresa[] = [];
    produtosComEmpresas: ProdutoComEmpresaResponse[] = [];
    familias: FamiliaResponse[] = [];
    // pizzas: ProdutosPizzaLasanhaComEmpresa[] = [];
    // lasanhas: ProdutosPizzaLasanhaComEmpresa[] = [];
    // tamanhosPizza: string[] = [];
    // tamanhosLasanha: string[] = [];
}

export class Tamanho {
    codigoCategoria: number = 0;
    nome: string = '';
    tamanho: number = 0;
}

export class TamanhoModel {
    codigoCategoria: number = 0;
    nome: string = '';
    tamanho: number = 0;
    valor: number = 0;
}

export class ProdutosComTamanhoRequest {
    codigoProdutosCategorias: number;
    tamanho: number;

    public static Get(codigoCategoria: number, tamanho: number): ProdutosComTamanhoRequest {
        var novo = new ProdutosComTamanhoRequest();
        novo.codigoProdutosCategorias = codigoCategoria;
        novo.tamanho = tamanho;
        return novo;
    }
}

export class ProdutoPizzaLasanhaQtdSabores {
    codigoProdutosCategorias: number = 0;
    qtdSabores: number = 0;
    codigo: number = 0;
}